import * as docx from 'docx-preview'
import React, { useEffect, useRef } from 'react'

import type { GetBinaryFileContentResponse } from 'services/results/types'

import { DOCX_FILE_PREVIEW_TEST_ID } from './FileContent'
import { DocxFilePreview, Wrapper } from './FileContents.styles'
import { NoContent } from './NoContent'

interface DocxViewerProps {
  data?: GetBinaryFileContentResponse
}

export const DocxViewer = ({ data }: DocxViewerProps) => {
  const docxFilePreviewContainerRef = useRef<HTMLDivElement>(null)

  const renderDocxFile = (data: GetBinaryFileContentResponse): void => {
    docx.renderAsync(data.fileContent, docxFilePreviewContainerRef.current as HTMLElement, undefined, {
      useBase64URL: true,
      inWrapper: true,
      ignoreWidth: false,
      ignoreHeight: false,
      ignoreFonts: false,
      breakPages: true,
      renderHeaders: true,
      renderFooters: true,
      renderFootnotes: true,
      renderEndnotes: true
    })
  }

  useEffect(() => {
    if (data) renderDocxFile(data)
  }, [data])

  if (!data) return <NoContent />

  return (
    <Wrapper data-testid={DOCX_FILE_PREVIEW_TEST_ID}>
      <DocxFilePreview ref={docxFilePreviewContainerRef} />
    </Wrapper>
  )
}
